import axios from 'axios';
import { API } from '../global/global';

export interface UbicacionDispositivo {
  id: number;
  nombre_dispositivo: string;
  imei: string;
  marca: string;
  modelo: string;
  estatus: string;
  latitud: number;
  longitud: number;
  precision?: number;
  direccion_aproximada?: string;
  ultima_ubicacion: string;
  gps_activo: boolean;
}

export interface HistorialUbicacion {
  id: number;
  dispositivo_id: number;
  latitud: number;
  longitud: number;
  precision?: number;
  direccion_aproximada?: string;
  velocidad?: number;
  altitud?: number;
  timestamp_ubicacion: string;
  tipo_registro: 'automatico' | 'manual' | 'geocerca';
  metadatos?: any;
  created_at: string;
  updated_at: string;
}

export interface EventoGeocerca {
  id: number;
  dispositivo_id: number;
  geocerca_id: number;
  tipo_evento: 'entrada' | 'salida';
  latitud: number;
  longitud: number;
  timestamp_evento: string;
  descripcion?: string;
  datos_adicionales?: any;
  notificado: boolean;
  dispositivo: {
    id: number;
    nombre_dispositivo: string;
    imei: string;
  };
  geocerca: {
    id: number;
    nombre: string;
    color: string;
  };
  created_at: string;
  updated_at: string;
}

export interface ActualizarUbicacionRequest {
  latitud: number;
  longitud: number;
  precision?: number;
  velocidad?: number;
  altitud?: number;
  direccion_aproximada?: string;
}

export const obtenerUbicacionesDispositivos = async (token: string): Promise<UbicacionDispositivo[]> => {
  const response = await axios.get(`${API}/ubicaciones`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data.data;
};

export const actualizarUbicacionDispositivo = async (
  dispositivoId: number, 
  ubicacion: ActualizarUbicacionRequest, 
  token: string
) => {
  const response = await axios.post(`${API}/ubicaciones/dispositivo/${dispositivoId}`, ubicacion, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data.data;
};

export const obtenerHistorialUbicacion = async (
  dispositivoId: number, 
  token: string,
  params?: {
    fecha_inicio?: string;
    fecha_fin?: string;
    limite?: number;
  }
) => {
  const response = await axios.get(`${API}/ubicaciones/dispositivo/${dispositivoId}/historial`, {
    headers: {
      Authorization: `Bearer ${token}`
    },
    params
  });
  return response.data.data;
};

export const obtenerEventosGeocerca = async (
  token: string,
  params?: {
    dispositivo_id?: number;
    geocerca_id?: number;
    tipo_evento?: 'entrada' | 'salida';
    fecha_inicio?: string;
    fecha_fin?: string;
    limite?: number;
  }
): Promise<EventoGeocerca[]> => {
  const response = await axios.get(`${API}/ubicaciones/eventos-geocerca`, {
    headers: {
      Authorization: `Bearer ${token}`
    },
    params
  });
  return response.data.data;
};

export const simularUbicaciones = async (token: string) => {
  const response = await axios.post(`${API}/ubicaciones/simular`, {}, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data.data;
};
